import { useTranslation } from "react-i18next";
import { Flex } from "../Flex";
import { Text } from "../Text";
import { ActivityTimeline } from "./ActivityTimeline";
import { BaseTask } from "../../model/task/Task";
import { Entry } from "../../model/entry/Entry";
import { KanbanCard } from "../../model/kanban/KanbanCard";
import { AtiraEmpty } from "../AtiraEmpty";
import { BaseModuleInstance } from "../../model/module/types/module-instance/BaseModuleInstance";
import { Form } from "../../model/form/Form";

type EntitiyType = Entry | BaseTask | KanbanCard | BaseModuleInstance | Form;

type Props<T extends EntitiyType> = {
  entity?: Partial<T>;
};

export const ActivityTab = <T extends EntitiyType>({ entity }: Props<T>) => {
  const { t } = useTranslation();
  const name =
    (entity as unknown as BaseTask).name ||
    (entity as unknown as Entry)?.fields?.email ||
    (entity as unknown as Entry)?.fields?.phone ||
    (entity as unknown as KanbanCard | Form)?.title;
  const data =
    [
      (entity as unknown as Entry)?.allActivities || [],
      (entity as unknown as KanbanCard)?.allActivities || [],
      (entity as unknown as BaseTask | BaseModuleInstance | Form)?.activities ||
        [],
    ].find((arr) => arr && arr.length > 0) || [];

  if (!entity) {
    return <AtiraEmpty description={t("common.noDataToShow")} />;
  }

  return (
    <Flex flexDirection="column" gap="m">
      <Text>
        {t("common.activities")} - {name}
      </Text>
      <ActivityTimeline activities={data} />
    </Flex>
  );
};
